/**
 * Section-completion tracking for the v2 Profile Rewrite workflow.
 * Keys: `blayzrr.rewrite.progress.<analysisId>` → { headline: true, about: false, ... }
 * localStorage only — per user's request, no backend sync.
 */
const KEY = (aid) => `blayzrr.rewrite.progress.${aid || 'unknown'}`;

export function readProgress(analysisId) {
  try {
    const raw = window.localStorage.getItem(KEY(analysisId));
    return raw ? (JSON.parse(raw) || {}) : {};
  } catch { return {}; }
}

export function writeProgress(analysisId, next) {
  try { window.localStorage.setItem(KEY(analysisId), JSON.stringify(next || {})); } catch { /* ignore */ }
}

export function markSectionComplete(analysisId, sectionKey, done = true) {
  const cur = readProgress(analysisId);
  cur[sectionKey] = !!done;
  writeProgress(analysisId, cur);
  return cur;
}
